import { EmptyState } from "@uzverse/ui";
import { useTranslation } from "react-i18next";
import { useCommonT } from "../components/common.js";
import { ApprovalCard } from "../components/ApprovalCard.js";
import { useSession } from "../state/session.js";
import { useAppState } from "../state/useAppState.js";

export function ApprovalsPage() {
  const { t } = useTranslation("web");
  const tc = useCommonT();
  const { client } = useSession();
  const { approvals } = useAppState();
  const all = Object.values(approvals).sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  const pending = all.filter((a) => a.status === "pending");
  const resolved = all.filter((a) => a.status !== "pending");
  const decide = (id: string, decision: "approved" | "rejected") =>
    client?.respondToApproval(id, decision);
  return (
    <section aria-labelledby="approvals-title" className="stack">
      <h1 id="approvals-title">{t("approvals.title")}</h1>
      <p className="muted">{t("approvals.intro")}</p>
      {all.length === 0 && <EmptyState t={tc} title={t("approvals.empty")} />}
      {pending.length > 0 && (
        <>
          <h2>{t("approvals.pending")}</h2>
          {pending.map((a) => (
            <ApprovalCard key={a.id} approval={a} onDecide={decide} />
          ))}
        </>
      )}
      {resolved.length > 0 && (
        <>
          <h2>{t("approvals.resolved")}</h2>
          {resolved.map((a) => (
            <ApprovalCard key={a.id} approval={a} onDecide={decide} />
          ))}
        </>
      )}
    </section>
  );
}
